import "@/i18n";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import LoginPage from "@/pages/LoginPage";
import DriverHome from "@/pages/driver/DriverHome";
import AttendanceForm from "@/pages/driver/AttendanceForm";
import ExpenseForm from "@/pages/driver/ExpenseForm";
import History from "@/pages/driver/History";
import DriverReports from "@/pages/driver/DriverReports";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import EmployeesPage from "@/pages/admin/EmployeesPage";
import AttendanceReview from "@/pages/admin/AttendanceReview";
import ExpenseReview from "@/pages/admin/ExpenseReview";
import AdminReports from "@/pages/admin/AdminReports";
import AdminNotifications from "@/pages/admin/AdminNotifications";
import ExpenseCategoriesPage from "@/pages/admin/ExpenseCategoriesPage";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <div className="container">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "driver") return <Navigate to="/driver" replace />;
  if (user.role === "report_viewer") return <Navigate to="/admin/reports" replace />;
  return <Navigate to="/admin" replace />;
}

// Report-viewer users hitting /admin get bounced to /admin/reports (they have no dashboard/employees/reviews).
function AdminRootRedirect({ children }) {
  const { user } = useAuth();
  if (user?.role === "report_viewer") return <Navigate to="/admin/reports" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/driver" element={<ProtectedRoute roles={["driver"]}><DriverHome /></ProtectedRoute>} />
          <Route path="/driver/attendance" element={<ProtectedRoute roles={["driver"]}><AttendanceForm /></ProtectedRoute>} />
          <Route path="/driver/expense" element={<ProtectedRoute roles={["driver"]}><ExpenseForm /></ProtectedRoute>} />
          <Route path="/driver/history" element={<ProtectedRoute roles={["driver"]}><History /></ProtectedRoute>} />
          <Route path="/driver/reports" element={<ProtectedRoute roles={["driver"]}><DriverReports /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute roles={["super_admin", "hr_admin", "report_viewer"]}><AdminLayout /></ProtectedRoute>}>
            <Route index element={<AdminRootRedirect><AdminDashboard /></AdminRootRedirect>} />
            <Route path="employees" element={<ProtectedRoute roles={["super_admin", "hr_admin"]}><EmployeesPage /></ProtectedRoute>} />
            <Route path="attendance" element={<ProtectedRoute roles={["super_admin", "hr_admin"]}><AttendanceReview /></ProtectedRoute>} />
            <Route path="expenses" element={<ProtectedRoute roles={["super_admin", "hr_admin"]}><ExpenseReview /></ProtectedRoute>} />
            <Route path="notifications" element={<ProtectedRoute roles={["super_admin", "hr_admin"]}><AdminNotifications /></ProtectedRoute>} />
            <Route path="expense-categories" element={<ProtectedRoute roles={["super_admin", "hr_admin"]}><ExpenseCategoriesPage /></ProtectedRoute>} />
            <Route path="reports" element={<AdminReports />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
